<script setup lang="ts">
import FinestCountBadge from '@/components/FinestCountBadge.vue'
import type { PortfolioRow } from '@/components/portfolio/portfolioRows'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  row: PortfolioRow
}>()

const { t } = useI18n({ useScope: 'local' })

const missingHint = computed(() => t('missing', { count: props.row.missingFields }, props.row.missingFields))

const location = computed(() => `${props.row.zipCode} ${props.row.city}`.trim())
</script>

<template>
  <div class="flex max-w-65 items-center gap-2">
    <!-- Reserved width so complete rows keep the same indent as flagged ones. -->
    <span class="flex min-w-5 flex-none justify-center">
      <FinestCountBadge :count="row.missingFields" :aria-label="missingHint" :title="missingHint" />
    </span>
    <div class="min-w-0">
      <div class="truncate font-bold" :title="row.addressLine">{{ row.addressLine }}</div>
      <div class="text-ink-3 truncate text-xs">{{ location }}</div>
    </div>
  </div>
</template>

<i18n lang="json">
{
  "de": {
    "missing": "{count} Angaben fehlen | {count} Angabe fehlt | {count} Angaben fehlen"
  },
  "en": {
    "missing": "{count} details missing | {count} detail missing | {count} details missing"
  }
}
</i18n>
